module.exports = __webpack_public_path__ + "static/media/Referrals.639784e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Images/Referrals.png
// module id = 239
// module chunks = 0